import { render } from "./tender_history.vue?vue&type=template&id=41d7dfe4"
import script from "./tender_history.vue?vue&type=script&lang=js"
export * from "./tender_history.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/inside/tabs/tender_history.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41d7dfe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41d7dfe4', __exports__)) {
    console.log('reload')
    api.reload('41d7dfe4', __exports__)
  }
  
  module.hot.accept("./tender_history.vue?vue&type=template&id=41d7dfe4", () => {
    console.log('re-render')
    api.rerender('41d7dfe4', render)
  })

}


export default __exports__